import { useEffect, useState } from "react";
import { isDef } from "@/util/validate";
import { useSelector } from "react-redux";
import { RootState } from "@/redux/store";

export const useUserInfo = () => {
	const { userInfo, isAdminType, nativeUser } = useSelector(
		(state: RootState) => state.auth
	);

	const [nickname, setNickname] = useState(userInfo?.nickname ?? "");
	useEffect(() => {
		if (!isAdminType) {
			if (isDef(nativeUser)) {
				setNickname(nativeUser.name);
				return;
			}
		}
		if (Boolean(isAdminType)) {
			setNickname(userInfo?.income?.nickname ?? "");
		}
	}, []);

	return {
		nickname,
	}; // 返回nickname
};
